import React, { useContext } from "react";

export const ActionCard = ({
  title,
  count,
  description,
  buttonText,
  onButtonClick,
  buttonHref,
}) => {
  return (
    <div className="col action-card-wrapper">
      <div className="action-card">
        <div className="row">
          <div className="col">
            <div className="t--500 mb-2 t--md">{title}</div>
            <div className="t--xl t--500">{count}</div>
          </div>
          <div className="col t--secondary d-none d-lg-block">
            <div className="mb-3 t--sm">{description}</div>
            {onButtonClick ? (
              <button
                disabled={!onButtonClick}
                className="button button--white"
                onClick={onButtonClick}
              >
                {buttonText}
              </button>
            ) : null}
            {buttonHref ? (
              <a href={buttonHref} rel="noopener noreferrer">
                <button className="button button--white">{buttonText}</button>
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
